/**
 * 🏗️ SCHEMA BUILDER (The Relational Join)
 * Location: src/registered/site-admin/components/Workflow-esg/services/schemaBuilder.js
 * Purpose: Joins the Presentation skeleton with Calculation rules and 
 * physically nests children into a recursive tree structure.
 */
export default function buildSchema(presentation, dimensions, calculationMap) {
  // Extract both the concept list and the designated Root IDs
  const { concepts, roots } = presentation;

  // 1. THE RELATIONAL JOIN: Enriching the "Business Face" with the "Finance Face"
  Object.keys(concepts).forEach(id => {
    const mathMatch = calculationMap[id];
    
    // Attach the Finance Logic directly to the Presentation node
    concepts[id].finance_logic = mathMatch ? {
      weight: mathMatch.weight,
      format: mathMatch.format,
      balance: mathMatch.balance
    } : null;

    // Initialize children array for nesting
    concepts[id].children = [];
  });

  // 2. THE MASTER-SERVANT NESTING: Physical Tree Construction
  const conceptList = Object.values(concepts).sort((a, b) => a.level - b.level);
  const finalRoots = [];
  const stack = [];

  conceptList.forEach(node => {
    const level = node.level;

    if (level === 1) {
      finalRoots.push(node.id);
      stack[0] = node;
    } else {
      // Find the parent in the stack (the most recent node at level - 1)
      const parentNode = stack[level - 2];
      
      if (parentNode) {
        // Physically push the servant into the master's children array
        parentNode.children.push(node.id); // Storing ID reference for cleaner state
        node.parent = parentNode.id;
      } else {
        // Fallback: If a level is skipped, treat as a new root
        finalRoots.push(node.id);
      }
      stack[level - 1] = node;
    }
    stack.length = level;
  });

  // 3. RETURN THE INTEGRATED POT
  // We use 'roots' here to satisfy ESLint and provide the UI entry points
  return { 
    concepts, 
    roots: finalRoots.length > 0 ? [...new Set(finalRoots)] : roots,
    meta: {
      generatedAt: new Date().toISOString(),
      totalConcepts: Object.keys(concepts).length
    }
  };
}